// What to tell an operator after sending a reward to a room full of fans.
//
// Pulled out of SendRewards so it can be tested: the only way to exercise this
// in the app is to actually email real people, which is not a thing to do to
// check a message. The bug it replaces reported success unconditionally —
// requests were fired without being awaited and 'Emails sent' followed
// immediately, so a send that failed for every fan still looked like it worked.
//
// results: [{ ok: boolean, email, error }]
// withoutEmail: checked-in fans who had no address on file and were skipped

export function summariseSend(results, withoutEmail = 0) {
    const attempted = results.length;
    const failed = results.filter(r => !r.ok).length;
    const sent = attempted - failed;

    const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
    const skipped = withoutEmail > 0
        ? ` ${plural(withoutEmail, 'checked-in fan has', 'checked-in fans have')} no email address on file and could not be sent one.`
        : '';

    // Nothing was even attempted: everyone lacked an address.
    if (attempted === 0) {
        return {
            kind: 'error',
            title: 'Nobody could be emailed',
            text: withoutEmail > 0
                ? `None of the ${plural(withoutEmail, 'checked-in fan', 'checked-in fans')} has an email address on file, so the reward was not sent to anyone.`
                : 'There was nobody to send the reward to.'
        };
    }

    if (sent === 0) {
        return {
            kind: 'error',
            title: 'Nothing was sent',
            text: `The reward could not be sent to any of the ${plural(attempted, 'fan', 'fans')}. Check your connection and try again.${skipped}`
        };
    }

    // The case worth being loudest about: some fans hold the reward and some
    // do not, and only this message says which.
    if (failed > 0) {
        return {
            kind: 'warning',
            title: 'Sent to some fans',
            text: `Sent to ${sent} of ${attempted}. ${plural(failed, 'fan', 'fans')} did not receive the reward.${skipped}`
        };
    }

    if (withoutEmail > 0) {
        return {
            kind: 'warning',
            title: 'Sent, with some fans skipped',
            text: `Reward sent to ${plural(sent, 'fan', 'fans')}.${skipped}`
        };
    }

    return {
        kind: 'success',
        title: `Reward sent to ${plural(sent, 'fan', 'fans')}`,
        text: ''
    };
}
